import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, useMediaQuery } from '@chakra-ui/react';
import { formatPrice, formatCurrency } from '@whitbread-eos/utils';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { Info } from '../../assets/icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Tooltip = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('../Tooltip/Tooltip.component'),
    Tooltip = _yield$import.default;
  return {
    default: Tooltip
  };
}), {
  ssr: false
});
var SubPrice = _ref2 => {
  var currencyCode = _ref2.currencyCode,
    label = _ref2.label,
    price = _ref2.price,
    language = _ref2.language,
    infoIcon = _ref2.infoIcon,
    tooltipContent = _ref2.tooltipContent,
    _ref2$defaultLayout = _ref2.defaultLayout,
    defaultLayout = _ref2$defaultLayout === void 0 ? true : _ref2$defaultLayout,
    cityTaxStyles = _ref2.cityTaxStyles;
  var _useMediaQuery = useMediaQuery('(max-width: 767px)'),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    isMobile = _useMediaQuery2[0];
  var isTouchDevice = navigator.maxTouchPoints > 0;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return _jsxs(_Fragment, {
    children: [_jsxs(Box, _objectSpread(_objectSpread({}, styles.wrapperStyles), {}, {
      "data-testid": "subPrice_text",
      children: [_jsxs(Box, _objectSpread(_objectSpread(_objectSpread({}, styles.roomPriceStyles), cityTaxStyles === null || cityTaxStyles === void 0 ? void 0 : cityTaxStyles.labelStyle), {}, {
        children: [label, infoIcon && _jsx(Tooltip, {
          title: tooltipContent.title,
          description: tooltipContent.description,
          variant: "infoGrey",
          placement: "bottom-start",
          hasArrow: true,
          closeDelay: 1500,
          isOpen: isTouchDevice || isMobile ? isOpen : undefined,
          onClose: () => setIsOpen(false),
          pointerEvents: "auto",
          position: "relative",
          sx: _objectSpread(_objectSpread({}, styles.tooltip), {}, {
            '[data-popper-placement="bottom-start"] & [data-popper-arrow-inner],[data-popper-placement="bottom-end"] & [data-popper-arrow-inner]': {
              bg: 'var(--chakra-colors-white) !important',
              width: 'var(--chakra-space-xmd) !important',
              height: 'var(--chakra-space-xmd) !important',
              borderLeft: '1px solid var(--chakra-colors-primary)',
              borderTop: '1px solid var(--chakra-colors-primary)',
              top: '-3px !important'
            },
            '[data-popper-placement="top-start"] & [data-popper-arrow-inner], [data-popper-placement="top-end"] & [data-popper-arrow-inner]': {
              bg: 'var(--chakra-colors-white) !important',
              width: 'var(--chakra-space-xmd) !important',
              height: 'var(--chakra-space-xmd) !important',
              borderRight: '1px solid var(--chakra-colors-primary)',
              borderBottom: '1px solid var(--chakra-colors-primary)',
              top: '1px !important'
            }
          }),
          alertElementStyles: {
            padding: '0.5rem 0.25rem 0.5rem 0'
          },
          children: _jsx(Box, _objectSpread(_objectSpread({}, styles.tooltipIcon), {}, {
            onClick: e => {
              e.stopPropagation();
              setIsOpen(prev => !prev);
            },
            children: _jsx(Info, {})
          }))
        })]
      })), defaultLayout && _jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, styles.roomPriceStyles), cityTaxStyles === null || cityTaxStyles === void 0 ? void 0 : cityTaxStyles.priceStyle), {}, {
        children: formatPrice(formatCurrency(currencyCode), price.toFixed(2), language)
      }))]
    })), !defaultLayout && _jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, styles.roomPriceStyles), cityTaxStyles === null || cityTaxStyles === void 0 ? void 0 : cityTaxStyles.priceStyle), {}, {
      mb: 4,
      children: formatPrice(formatCurrency(currencyCode), price.toFixed(2), language)
    }))]
  });
};
export default SubPrice;
var styles = {
  wrapperStyles: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  roomPriceStyles: {
    display: 'inline-block'
  },
  tooltip: {
    bg: 'var(--chakra-colors-white)',
    color: 'var(--chakra-colors-darkGrey1)',
    border: '1px solid var(--chakra-colors-primary)',
    left: {
      mobile: '10px',
      xs: '-7px'
    },
    top: '5px',
    _before: {
      display: 'none'
    },
    width: {
      mobile: 'calc(100% - 20px)',
      xs: 'auto'
    }
  },
  tooltipIcon: {
    display: 'inline-block',
    marginLeft: '4px',
    marginTop: '-2px',
    verticalAlign: 'middle',
    cursor: 'pointer'
  }
};